import MxImageBlur from "@rf-l1/images/MxImageBlur";

import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { MxJiraCustomComponentProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { AutoCompleteItemOption } from "@rf-l1/form/selects/MxAutoCompleteField/MxAutoCompleteField";

export type agencyAutoCompleteItem = I_GENERIC_ITEMS<{
    agencyData: {
      id: string;
      name: string;
      picture: string;
    };
  }>
export const MxItemAgencies = (
  props: MxJiraCustomComponentProps<agencyAutoCompleteItem>
) => {
  const { item, ...rest } = props;
  return (
    <AutoCompleteItemOption {...rest}>
      <Grid container alignItems="center" p={0.5} columnSpacing={1}>
        <Grid item xs="auto">
          <MxImageBlur
            src={item.extraData?.agencyData.picture}
            width={30}
            height={30}
            borderRadius={30}
            objectFit="cover"
          />
        </Grid>
        <Grid container item flex={1} rowSpacing={0.2}>
          <Grid item xs={12}>
            <MxTypography variant="overline" fontWeight={500} color="grey.600">
              {item.extraData?.agencyData.name}
            </MxTypography>
          </Grid>
        </Grid>
      </Grid>
    </AutoCompleteItemOption>
  );
};
